<div class="permissions-modal full-height">
    <div class="permissions-modal-header">
        <svg-icon [src]="'assets/svg/unlock.svg' | assetVersion" alt="Unlock" class="svg-icon"></svg-icon>
        <p>
            <strong>Recuerda darnos accesos a los siguientes permisos:</strong>
        </p>
    </div>
    <div class="permissions-container full-height-scroll">
        <div class="permissions-list">
            <ng-container *ngFor="let permission of (permissions | async)">
                <div class="permission-item">
                    <ion-toggle class="permission-toggle" mode="ios"
                        [checked]="permission.state === 'granted'"
                        [disabled]="permission.state !== 'prompt'"
                        (ionChange)="requestPermission(permission)"
                        ></ion-toggle>
                    <div class="permission-label">
                        <p>{{ permission.name }}</p>
                        <p>
                            {{textRef | async}}
                        </p>
                        <!-- <ion-icon [name]="getPermissionIcon(permission)"></ion-icon> -->
                    </div>
                </div>
                <p>
                    {{permission | json}}
                </p>
                <!-- @if (permission.state === 'denied') {
                    <p class="denied">{{permissionGuideText}}</p>
                } -->
            </ng-container>
        </div>
        <div class="camera-container-modal">
            <!-- <video #camera autoplay muted class="media" playsinline></video>
            <ng-container [ngSwitch]="cameraStatus">
                <button 
                (click)="toggleCamera()"
                *ngSwitchCase="off">Abrir cámara</button>
                <button *ngSwitchCase="on">Cerrar cámara</button>
                <p *ngSwitchCase="not-allowed">No permitida</p>
            </ng-container> -->
        </div>
    </div>
    <p>
        @if (allPermissionsGranted | async) {
            ¡Listo! Ya puedes continuar.
        }
        @else {
            Asegúrate de darnos acceso a todos los permisos para continuar.
        }
    </p>
    <div class="confirm-button">
        <app-app-button (click)="closeModal()" [disabled]="!(allPermissionsGranted | async)" text="Siguiente"
            icon="chevron-forward">
        </app-app-button>
    </div>
</div>